import { createContext } from 'react'

export type ToastType = 'success' | 'error'
export type ExtendedToastType = ToastType | 'warning' | 'info' | 'loading'

export type ToastContextType = {
  showToast: (type: ExtendedToastType, title: string, message?: string) => void
}

export const ToastContext = createContext<ToastContextType | undefined>(undefined)
